export const receivingNotePurposeOptions = [
    { value: "1", label: "ΔΠΠ - ΜΗ ΥΠΟΧΡΕΟΣ ΕΚΔΟΣΗΣ" },
    { value: "2", label: "ΔΠΠ - ΑΡΝΗΣΗ ΕΚΔΟΣΗΣ/ΕΚ ΠΑΡΑΔΡΟΜΗΣ ΜΗ ΕΚΔΟΣΗ" },
    { value: "3", label: "ΔΠΠ - ΕΝΔΟΚΟΙΝΟΤΙΚΗ ΑΠΟΚΤΗΣΗ" },
    { value: "4", label: "ΔΠΠ - ΑΠΟΚΤΗΣΗ ΤΡΙΤΗ ΧΩΡΑ" },
    { value: "5", label: "ΔΠΠ - ΠΟΣΟΤΙΚΟΣ ΕΛΕΓΧΟΣ" },
    { value: "6", label: "ΔΠΠ - ΜΗ/ΜΕΡΙΚΗ ΠΑΡΑΔΟΣΗ" },
    { value: "7", label: "ΔΠΠ - ΛΟΙΠΕΣ ΠΕΡΙΠΤΩΣΕΙΣ" }
];
